// antd DatePicker and RangePicker on the US Pacific calendar: the highlighted "today", the
// Today / Now buttons and the month the calendar opens on follow Pacific time, not the PC clock.
// Values are ordinary picker values: load them with toPickerValue() and save them with
// fromPickerValue() (date + time) or fromPickerDate() (date only) from utils/usTime.
import { DatePicker } from 'antd';
import dayjsGenerateConfig from 'rc-picker/es/generate/dayjs';
import { nowPickerValue } from '../../utils/usTime';

const PTDatePicker = DatePicker.generatePicker({
  ...dayjsGenerateConfig,
  getNow: () => nowPickerValue(),
});

export const PTRangePicker = PTDatePicker.RangePicker;

export default PTDatePicker;
